import React from "react";

export const CardImage = ({ image, fade }) => {
    return (
        <div className="col-sm-4 mb-3 mb-sm-0" data-aos={fade}>
            <div className="card welcome-image-wrapper">
                <img 
                    src={image} 
                    alt="Academia Balam Boox" 
                    className="welcome-img" 
                />
            </div>
        </div>
    );
};